<template>
  <div class="medical-record-exam">
    <div class="border-title text-center">
      <label class="form-label text-bold mb-2">Biometria</label>
      <div class="columns">
        <div class="column col-4 text-bold"></div>
        <div class="column col-4 text-bold">OD</div>
        <div class="column col-4 text-bold">OE</div>
      </div>
    </div>
    <div class="border-items">
      <div class="columns">
        <div class="column col-4 form-group centered">Ceratometria Média (K)</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.cornealCurvatureR"
                   step="0.01" min="25" max="70"
                   placeholder="25,00 - 70,00"
                   data-tabindex="1">
            <span class="input-group-addon">D</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.cornealCurvatureL"
                   step="0.01" min="25" max="70"
                   placeholder="25,00 - 70,00"
                   data-tabindex="2">
            <span class="input-group-addon">D</span>
          </div>
        </div>

        <div class="column col-4 form-group centered">Cyl / Eixo</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.cylinderR"
                   step="0.01" min="0" max="25"
                   placeholder="0,00 - 25,00"
                   data-tabindex="1">
            <input type="number" class="form-input text-center"
                   v-model="form.axisR"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="1">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.cylinderL"
                   step="0.01" min="0" max="25"
                   placeholder="0,00 - 25,00"
                   data-tabindex="2">
            <input type="number" class="form-input text-center"
                   v-model="form.axisL"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="2">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group centered">AL</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.axialLengthR"
                   step="0.01" min="15" max="40"
                   placeholder="15,00 - 40,00"
                   data-tabindex="1">
            <span class="input-group-addon">mm</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.axialLengthL"
                   step="0.01" min="15" max="40"
                   placeholder="15,00 - 40,00"
                   data-tabindex="2">
            <span class="input-group-addon">mm</span>
          </div>
        </div>

        <div class="column col-4 form-group centered">ACD</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.anteriorChamberDepthR"
                   step="0.01" min="1" max="6"
                   placeholder="1,00 - 6,00"
                   data-tabindex="1">
            <span class="input-group-addon">mm</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.anteriorChamberDepthL"
                   step="0.01" min="1" max="6"
                   placeholder="1,00 - 6,00"
                   data-tabindex="2">
            <span class="input-group-addon">mm</span>
          </div>
        </div>

        <div class="column col-4 form-group centered">LT</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.lensThicknessR"
                   step="0.01" min="2" max="8"
                   placeholder="2,00 - 8,00"
                   data-tabindex="1">
            <span class="input-group-addon">mm</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.lensThicknessL"
                   step="0.01" min="2" max="8"
                   placeholder="2,00 - 8,00"
                   data-tabindex="2">
            <span class="input-group-addon">mm</span>
          </div>
        </div>

        <div class="column col-4 form-group centered">Escolha LIO OD</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input" placeholder="Escolha LIO olho direito..."
                 v-model="form.intraocularLensR">
        </div>

        <div class="column col-4 form-group centered">Escolha LIO OE</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input" placeholder="Escolha LIO olho esquerdo..."
                 v-model="form.intraocularLensL">
        </div>

        <div class="column col-4 form-group centered">Observação</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input" placeholder="Observações..."
                 v-model="form.observations">
        </div>
      </div>

      <st-entity-file-manager
        v-if="form.id"
        :entity-id="patient.id"
        :origin-id="medicalRecordId"
        :origin-child-id="form.id"
        origin-type="medical_record_exam"
        :key="medicalRecordId"
      />

      <div class="text-center btn-icon btn-icon-left mt-2">
        <button
          type="button"
          class="btn btn-info mr-2"
          :class="{ loading: saving }"
          @click="save"
        ><fa-icon :icon="['fal', 'save']" /> Salvar</button>
        <button
          type="button"
          class="btn btn-gray-outline btn-icon btn-icon-left mr-2"
          @click="$emit('cancel')"
        ><fa-icon :icon="['fal', 'times']" /> Cancelar</button>
        <button
          v-if="!triage"
          type="button"
          class="btn btn-info-outline btn-icon btn-icon-left mr-2"
          :disabled="true"
        ><fa-icon :icon="['fal', 'history']" /> Histórico</button>
        <st-button-report
          v-if="!triage"
          type="pdf"
          label="Imprimir"
          button-class="btn-gray mr-2"
          :route="printUrl"
          :options="[]"
        />
        <button
          type="button"
          class="btn btn-error btn-icon btn-icon-left"
          :class="{ loading: removing }"
          @click="promptRemoval"
        ><fa-icon :icon="['fal', 'trash']" /> Excluir</button>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from './formMixin';

export default {
  mixins: [formMixin],
  data() {
    return {
      form: {
        id: null,
        cornealCurvatureR: '',
        cornealCurvatureL: '',
        cylinderR: '',
        axisR: '',
        cylinderL: '',
        axisL: '',
        axialLengthR: '',
        axialLengthL: '',
        anteriorChamberDepthR: '',
        anteriorChamberDepthL: '',
        lensThicknessR: '',
        lensThicknessL: '',
        intraocularLensR: '',
        intraocularLensL: '',
        observations: '',
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

</style>
